import { Component, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PhotoOrder, PhotoOrderService } from '@lc/core';
import { Tab } from '@lc/ui';
import { Observable } from 'rxjs';
import {
  filter, map, startWith, switchMap, tap,
} from 'rxjs/operators';
import { AsyncPipe, DatePipe } from '@angular/common';
import { NavigationTabsComponent } from '@lc/ui/lib/tabs/components/navigation-tabs/navigation-tabs.component';
import { AddressPipe } from '@lc/core/lib/pipes/address.pipe';

@Component({
  selector: 'lc-manage-media',
  templateUrl: './manage-media.component.html',
  styleUrls: ['./manage-media.component.scss'],
  imports: [
    NavigationTabsComponent,
    AsyncPipe,
    DatePipe,
    AddressPipe,
  ],
})
export class ManageMediaComponent {
  private photoOrderService = inject(PhotoOrderService);
  private activatedRoute = inject(ActivatedRoute);

  readonly activeId$: Observable<string>;
  readonly tabs: Tab[] = [
    new Tab('Photos', 'photos', 'photos'),
    new Tab('Multimedia', 'multimedia', 'multimedia'),
  ];

  readonly photoOrder$: Observable<PhotoOrder>;
  photoOrderSelectedOptions:string;

  constructor() {
    const router = inject(Router);
    const { activatedRoute } = this;

    // Set the id of the active tab
    this.activeId$ = router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      startWith({}),
      map(() => activatedRoute.snapshot.children[0].data.activeId),
    );

    // Query the photo order
    this.photoOrder$ = this.activatedRoute.params.pipe(
      map((params) => params.photoOrderId),
      switchMap((orderId) => this.photoOrderService.getOrder$(orderId)),
      tap((order) => this.photoOrderSelectedOptions = (order.options || [])
        .filter((opt) => opt.selected).map((opt) => (opt.quantity ? `${opt.title} (${opt.quantity})` : opt.title))
        .join(', ')),
    );
  }
}
